<template>
  <button type="button" class="b-switch" :class="{ on: modelValue }" @click="$emit('update:modelValue', !modelValue)">
    <i :class="modelValue ? 'bi-toggle-on' : 'bi-toggle-off'" />
  </button>
</template>

<script>
export default {
  props: {
    modelValue: Boolean
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.b-switch {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 1.5rem;
  line-height: 1;
  color: var(--bs-gray-400);
  transition: color 0.15s;
}
.b-switch.on {
  color: var(--bs-dark);
}
</style>
